package components.project

import it.neckar.lizergy.model.configuration.quote.QuoteConfiguration
import it.neckar.lizergy.model.project.ResolvedProject
import it.neckar.react.common.form.*
import react.*

external interface BlueprintTabProps : Props {
  var project: ResolvedProject
}

external interface QuoteConfigurationTabProps : Props {
  var project: ResolvedProject
  var quoteConfiguration: QuoteConfiguration
  var editableStatus: EditableStatus
}
